import loadable from '@loadable/component';

/* Views */
import BreakView from './Break/View';
import TextView from './Text/View';
import NumbersView from './Numbers/View';
import AccordionView from './Accordion/View';
import TabsView from './Tabs/View';
import DownloadsTemplate from './Listing/Downloads/DownloadsTemplate';
import ListingLinkMore from './Listing/ListingLinkMore';

/* Edit */
const BreakEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Break/Edit'),
);
const NumbersEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Numbers/Edit'),
);
const AccordionEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Accordion/Edit'),
);
const TabsEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Tabs/Edit'),
);

/* Schema */
import NumbersSchema from './Numbers/Schema';
import AccordionSchema from './Accordion/Schema';
import TabsSchema from './Tabs/Schema';

export {
  BreakView,
  BreakEdit,
  TextView,
  NumbersView,
  NumbersEdit,
  NumbersSchema,
  AccordionView,
  AccordionEdit,
  AccordionSchema,
  DownloadsTemplate,
  ListingLinkMore,
  TabsView,
  TabsEdit,
  TabsSchema,
};
